import { render, staticRenderFns } from "./SeatsPage.vue?vue&type=template&id=578338c2&scoped=true&"
import script from "./SeatsPage.vue?vue&type=script&lang=js&"
export * from "./SeatsPage.vue?vue&type=script&lang=js&"
import style0 from "./SeatsPage.vue?vue&type=style&index=0&id=578338c2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "578338c2",
  null
  
)

export default component.exports